import React, { PureComponent } from 'react';
import LogMonitorEntry from './LogMonitorEntry.js';
export default class LogMonitorEntryList extends PureComponent {
    render() {
        const elements = [];
        const { theme, actionsById, computedStates, currentStateIndex, consecutiveToggleStartId, select, skippedActionIds, stagedActionIds, expandActionRoot, expandStateRoot, markStateDiff, onActionClick, onActionShiftClick, } = this.props;
        for (let i = 0; i < stagedActionIds.length; i++) {
            const actionId = stagedActionIds[i];
            const action = actionsById[actionId].action;
            const { state, error } = computedStates[i];
            let previousState;
            if (i > 0) {
                previousState = computedStates[i - 1].state;
            }
            elements.push(React.createElement(LogMonitorEntry, { key: actionId, theme: theme, select: select, action: action, actionId: actionId, state: state, previousState: previousState, collapsed: skippedActionIds.includes(actionId), inFuture: i > currentStateIndex, selected: consecutiveToggleStartId === i, error: error, expandActionRoot: expandActionRoot, expandStateRoot: expandStateRoot, markStateDiff: markStateDiff, onActionClick: onActionClick, onActionShiftClick: onActionShiftClick }));
        }
        return React.createElement("div", null, elements);
    }
}
